<template>
  <div class="card">
    <div class="card-body">
      <div class="custom-search d-flex flex-wrap align-items-center justify-content-between mb-1">
        <div class="d-flex flex-wrap align-items-center mb-50 mb-md-0">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1 mb-50 mb-sm-0"
            @click="$router.push({ name: 'block', params: { id: 'new' } })"
          >
            Новый блок
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="mr-1 mb-50 mb-sm-0"
            @click="handleOpenQueueModal"
          >
            Порядок блоков
          </b-button>
        </div>

        <div class="d-flex flex-wrap align-items-center settings-toolbar-filters">
          <b-form-group
            label="Тип блока"
            label-cols-sm="auto"
            class="mb-50 mb-sm-0 mr-1"
          >
            <v-select
              v-model="listKeyFilter"
              :options="blockTypeFilterOptions"
              :reduce="item => item.key"
              :get-option-label="item => item.label"
              :clearable="false"
              :searchable="false"
              class="settings-type-select"
            />
          </b-form-group>
          <b-form-group
            label="Поиск"
            label-cols-sm="auto"
            class="mb-0"
          >
            <b-form-input
              v-model="searchTerm"
              placeholder="Название или текст"
              type="text"
              class="d-inline-block settings-search-input"
            />
          </b-form-group>
        </div>
      </div>

      <p
        v-if="listKeyFilter !== 'all'"
        class="text-muted mb-1"
      >
        Показаны блоки: <strong>{{ blockTypeLabel(listKeyFilter) }}</strong>
        ({{ displayRows.length }})
      </p>

      <vue-good-table
        :columns="columns"
        :rows="displayRows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.field === 'typeLabel'">
            <b-badge :variant="blockTypeBadge(props.row.key)">
              {{ props.row.typeLabel }}
            </b-badge>
          </span>

          <span
            v-else-if="props.column.field === 'preview'"
            class="settings-preview-cell"
          >
            <img
              v-if="props.row.imageThumb"
              :src="props.row.imageThumb"
              alt=""
              class="settings-preview-thumb mr-50"
            >
            <span class="settings-preview-text">
              {{ props.row.preview }}
            </span>
            <b-badge
              v-if="props.row.buttonHint"
              variant="light-info"
              class="ml-50"
            >
              Кнопка: {{ props.row.buttonHint }}
            </b-badge>
          </span>

          <span v-else-if="props.column.field === 'order'">
            {{ props.row.order }}
          </span>

          <span v-else-if="props.column.field === 'createdAtLabel'">
            {{ props.row.createdAtLabel }}
          </span>

          <span v-else-if="props.column.field === 'action'">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

              <router-link
                :to="{ name: 'block', params: { id: props.row.id } }"
                class="edit-button"
              >
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Редактировать</span>
              </router-link>

              <b-dropdown-item
                @click="openDeleteModal(props.row)"
              >
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Удалить</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <div
          slot="emptystate"
          class="text-center text-muted py-2"
        >
          Нет блоков для выбранного типа
        </div>
      </vue-good-table>

      <infinite-loading
        ref="infloader"
        spinner="bubbles"
        @infinite="infiniteScroll"
      >
        <div slot="no-more" />
        <div slot="no-results" />
      </infinite-loading>
    </div>

    <b-modal
      id="modal-primary"
      v-model="modalIsOpen"
      ok-only
      ok-title="Отмена"
      modal-class="modal-primary"
      centered
      title="Удаление блока"
    >
      <div>
        Удалить блок
        <strong v-if="clubToDeletePreview">«{{ clubToDeletePreview }}»</strong>?
        Это изменение сразу отразится на странице клуба.
      </div>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        class="mt-1"
        variant="danger"
        @click="deleteItem(clubToDelete)"
      >
        Удалить
      </b-button>
    </b-modal>

    <b-modal
      id="modalQueue"
      v-model="isQueueOpen"
      no-close-on-backdrop
      hide-footer
      modal-class="modal-primary"
      centered
      title="Порядок блоков"
    >
      <label
        for="block-type-order"
        class="my-label"
      >Тип блока</label>
      <v-select
        id="block-type-order"
        v-model="keySelect"
        :close-on-select="true"
        :options="blockTypeOptions"
        :reduce="item => item.key"
        :get-option-label="item => item.label"
        :searchable="false"
        class="select mb-1 pb-0"
      />
      <p class="text-muted small mb-1">
        Перетащите строки, чтобы задать порядок на странице клуба. Затем нажмите «Сохранить».
      </p>
      <DragDropTable
        :items="queueRows"
        @select="handleSelectQueue"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import InfiniteLoading from 'vue-infinite-loading'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import crud_module from '../../../libs/crud_module'
import DragDropTable from '../DragDropTable.vue'

const settings_module = crud_module({
  entity_name: 'club-settings',
})

const BLOCK_TYPES = [
  { key: 'main_image', label: 'Главное изображение', badge: 'light-secondary' },
  { key: 'features', label: 'Фишки / бонусы', badge: 'light-primary' },
  { key: 'statistic', label: 'Статистика', badge: 'light-success' },
  { key: 'process', label: 'План как начать', badge: 'light-warning' },
]

export default {
  components: {
    VueGoodTable,
    BBadge,
    BFormGroup,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BButton,
    InfiniteLoading,
    vSelect,
    DragDropTable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      skipCount: 9,
      maxResultCount: 9,
      modalIsOpen: false,
      clubToDelete: null,
      clubToDeletePreview: '',
      isQueueOpen: false,
      keySelect: 'features',
      listKeyFilter: 'all',
      columns: [
        {
          label: 'Тип',
          field: 'typeLabel',
          sortable: true,
          width: '180px',
        },
        {
          label: 'Содержимое',
          field: 'preview',
          sortable: true,
        },
        {
          label: 'Порядок',
          field: 'order',
          sortable: true,
          width: '100px',
        },
        {
          label: 'Дата',
          field: 'createdAtLabel',
          sortable: true,
          width: '160px',
        },
        {
          label: 'Действие',
          field: 'action',
          sortable: false,
          width: '90px',
        },
      ],
      rows: [],
      searchTerm: '',
      blockTypeOptions: BLOCK_TYPES,
    }
  },
  computed: {
    blockTypeFilterOptions() {
      return [{ key: 'all', label: 'Все типы' }, ...BLOCK_TYPES]
    },
    displayRows() {
      const filtered = this.listKeyFilter === 'all'
        ? this.rows
        : this.rows.filter(row => row.key === this.listKeyFilter)

      return filtered.map(row => this.mapRowForTable(row))
    },
    queueRows() {
      return this.rows
        .filter(row => row.key === this.keySelect)
        .slice()
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map(row => ({
          ...row,
          name: this.getContentPreview(row),
        }))
    },
  },
  async created() {
    try {
      const payload = {
        skipCount: '',
        maxResultCount: this.maxResultCount,
      }
      this.rows = await settings_module.fetchItems(payload)
        .then(res => res.data.rows)
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    blockTypeMeta(key) {
      return BLOCK_TYPES.find(item => item.key === key)
        || { key, label: key || 'Неизвестный тип', badge: 'light-secondary' }
    },
    blockTypeLabel(key) {
      return this.blockTypeMeta(key).label
    },
    blockTypeBadge(key) {
      return this.blockTypeMeta(key).badge
    },
    stripHtml(value) {
      if (!value) return ''
      return String(value)
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    },
    getContentPreview(row) {
      const description = this.stripHtml(row.description)
      const name = (row.name || '').trim()

      if (row.key === 'main_image') {
        return name || 'Главное изображение страницы клуба'
      }
      if (row.key === 'process') {
        return description || 'Этап без текста'
      }
      if (row.key === 'statistic') {
        return name || description || 'Показатель статистики'
      }
      if (row.key === 'features') {
        return name || description || 'Фишка / бонус'
      }
      return name || description || 'Без названия'
    },
    mapRowForTable(row) {
      const typeMeta = this.blockTypeMeta(row.key)
      const preview = this.getContentPreview(row)
      const buttonHint = row.key === 'process' && (row.name || '').trim()
        ? (row.name || '').trim()
        : ''

      return {
        ...row,
        typeLabel: typeMeta.label,
        preview,
        buttonHint,
        imageThumb: row.image && row.image.fullPath ? row.image.fullPath : null,
        createdAtLabel: this.formatDate(row),
      }
    },
    openDeleteModal(row) {
      this.clubToDelete = row.id
      this.clubToDeletePreview = row.preview || this.getContentPreview(row)
      this.modalIsOpen = true
    },
    async infiniteScroll($state) {
      const payload = {
        skipCount: this.skipCount,
        maxResultCount: this.maxResultCount,
      }
      await settings_module.fetchItems(payload)
        .then(res => {
          if (res.data.rows.length > 0) {
            this.rows.push(...res.data.rows)
            this.skipCount += this.maxResultCount
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    async deleteItem(id) {
      const payload = {
        skipCount: '',
        maxResultCount: this.maxResultCount,
      }
      await settings_module.deleteItem(id)
      await settings_module.fetchItems(payload).then(response => {
        this.rows = response.data.rows
        this.skipCount = this.rows.length
      })
      this.modalIsOpen = false
      this.clubToDelete = null
      this.clubToDeletePreview = ''
    },
    async handleSelectQueue(value) {
      const payload = { order: value }
      await settings_module.updateOrder(payload).then(r => {
        if (r.data.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Уведомление',
              icon: 'BellIcon',
              text: 'Порядок сохранён',
              variant: 'success',
            },
          })
          this.updateData()
        }
      })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Уведомление',
              icon: 'BellIcon',
              text: error.response.data.message,
              variant: 'danger',
            },
          })
        })
      this.isQueueOpen = false
    },
    handleOpenQueueModal() {
      if (this.listKeyFilter !== 'all') {
        this.keySelect = this.listKeyFilter
      }
      this.isQueueOpen = true
    },
    async updateData() {
      this.rows = []
      this.skipCount = 0
      this.$refs.infloader.stateChanger.reset()
    },
    formatDate(rowObj) {
      if (!rowObj || !rowObj.createdAt) return '—'
      const newDate = new Date(rowObj.createdAt)
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return newDate.toLocaleDateString('ru', options)
    },
  },
}
</script>

<style lang="scss">
.my-label {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  width: 100%;
}

.edit-button {
  padding: 0.65rem 1.28rem;
  display: flex;
  align-items: center;

  &:hover {
    background-color: rgba(115, 103, 240, 0.12);
  }
}

.settings-type-select {
  min-width: 220px;
}

.settings-search-input {
  min-width: 200px;
}

.settings-preview-cell {
  display: inline-flex;
  align-items: center;
  max-width: 520px;
  flex-wrap: wrap;
}

.settings-preview-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

.settings-preview-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
